@if (data) {
  <div>
    <div>
      <p-checkbox #markAsFrozen name="markAsFrozen" [(ngModel)]="data.isDoNotTrade" [disabled]="isExternalAcct" binary="true" (onChange)="onInputChange();"
      inputId="spectritem1"></p-checkbox>
      <label for="spectritem1">Mark As Frozen</label>
      <span id="markAsFrozenToolTipIcon" class="infoIcon" calltoaction [calltoactionTemplate]="markAsFrozenToolTipIcon"></span>
    </div>
    <div class="reinvest-flex-container">
      <div class="reinvest-flex-child-left">
        <div>
          <p-checkbox #reinvestDiv name="reInvestDividend" [(ngModel)]="data.isDividendReinvest" binary="true" (onChange)="validateReinvestChange();" [disabled]="data.isSMA?'disabled':null"
          inputId="spectritem2"></p-checkbox>
          <label for="spectritem2">Reinvest dividends</label>
        </div>
        <div>
          <p-checkbox #reinvestCapGain name="reinvestCapGains" [(ngModel)]="data.isCapGainsReinvest" binary="true" (onChange)="validateReinvestChange();" [disabled]="data.isSMA?'disabled':null"
          inputId="spectritem3"></p-checkbox>
          <label for="spectritem3">Reinvest capital gains</label>
        </div>
      </div>
      <div class="reinvest-flex-child-right">
        <span class="reinvestmentScreenText">Select whether to automatically reinvest either dividends or capital gains - or both - for this account.</span>
      </div>
    </div>
  </div>
}

<ng-template #markAsFrozenToolTipIcon>
  <div>If checked, iRebal will never propose to buy/sell holdings in this account. Its holdings will still be included in allocation calculations.</div>
</ng-template>

<ng-template #reinvestUnsupportedConfigMessage>
  <div class="block"><strong>Unsupported:</strong><br/>
Dividends Yes, Capital Gains No</div>
<div><strong>Supported:</strong><br/>
Dividends Yes, Capital Gains Yes<br/>
Dividends No, Capital Gains Yes<br/>
Dividends No, Capital Gains No</div>
</ng-template>
